export const AdmissionDecisionEN = {
    "decisionAdmission": {
        "breadCrumb": {
            "add": "Add new Decision Admission",
            "update": "Update Decision Admission",
            "detail": "Detail Decision Admission"
        },
        "placeholder": {
            "no": "QD001",
            "date": "dd/mm/yyyy",
            "positionDecision": "Select",
            "employee": "Choose",
            "reason": "Choose",
            "lineManager": "Choose",
            "oldDepartment": "Choose",
            "oldPosition": "Choose",
            "oldJobTitle": "Choose",
            "newDepartment": "Choose",
            "newPosition": "Choose",
            "newJobTitle": "Choose",
            "description": "Choose",
            "reasonReward": "Choose reason"
        },
        "label": {
            "no": "Decision no.",
            "dateDecision": "Decision date",
            "dateEffective": "Validity date",
            "employee": "Employee",
            "reason": "Reason",
            "oldDepartment": "Current department",
            "oldPosition": "Current job position",
            "oldJobTitle": "Current job title",
            "newDepartment": "New department",
            "newPosition": "New job position",
            "newJobTitle": "New job title",
            "positionDecision": "Decision maker",
            "status": "Status",
            "description": "Desciption",
            "lineManager": "Direct manager"
        },
        "type": {
            "reward": {
                "heading": "Reward decision",
                "paid": "Paid",
                "addToSalary": "Add to salary"
            }
        },
        "message" : {
            "department": "Please select Admission Department",
            "jobPosition" : "Please select Admission Position",
            "jobTitle" : "Please select Admission Job Title"
        },
    }
}